import React, { useEffect, useState } from 'react'
import { ToastContainer, toast } from "react-toastify";

import Setting from '../setting/Setting'
import EditSetting from '../setting/EditSetting'
import GetCompanyInfoService from '../../services/company/getCompanyInfoService'

const Additionalsettings = ({setInputValue}) => {
  const [setting, setSetting] = useState([])

    useEffect(() => {
        GetCompanyInfoService.getCompanySettingInfo().then(
          (response) => {
            setSetting(response.data.company)
          }
        )
      }, [])
  return (
    <div className=" col-md-9 pt-3">
    {
      setting === null ?
        <Setting />
        :
        <EditSetting setInputValue={setInputValue}></EditSetting>
    }
  </div>
  )
}

export default Additionalsettings